import React from "react";
import { Heart, MessageCircle, Send, Bookmark } from "lucide-react";

export const PostPreview = ({ handle = "yourbusiness", image, caption, label, compact = false }) => (
  <article className="overflow-hidden rounded-2xl border border-slate-200 bg-white soft-shadow">
    <header className="flex items-center gap-2 px-3 py-2.5">
      <span className="h-7 w-7 rounded-full bg-gradient-to-br from-[#F95738] to-[#FFC43D]" aria-hidden="true" />
      <span className="text-xs font-semibold text-slate-800">{handle}</span>
      {label && (
        <span className="ml-auto rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
          {label}
        </span>
      )}
    </header>
    {image && (
      <img
        src={image}
        alt={caption ? caption.slice(0, 80) : "Social media post example"}
        loading="lazy"
        className={`w-full object-cover ${compact ? "h-32" : "h-48"}`}
      />
    )}
    <div className="px-3 pb-3 pt-2.5">
      <div className="flex items-center gap-3 text-slate-500" aria-hidden="true">
        <Heart className="h-4 w-4" />
        <MessageCircle className="h-4 w-4" />
        <Send className="h-4 w-4" />
        <Bookmark className="ml-auto h-4 w-4" />
      </div>
      {caption && (
        <p className="mt-2 whitespace-pre-line text-xs leading-relaxed text-slate-600 line-clamp-4">{caption}</p>
      )}
    </div>
  </article>
);

export const PhoneMockup = ({ children, className = "" }) => (
  <div
    className={`relative mx-auto w-full max-w-[300px] rounded-[2.5rem] border-[10px] border-slate-900 bg-slate-900 soft-shadow-lg ${className}`}
  >
    <div className="absolute left-1/2 top-2 z-10 h-1.5 w-16 -translate-x-1/2 rounded-full bg-slate-700" aria-hidden="true" />
    <div className="h-[520px] overflow-hidden rounded-[2rem] bg-[#FAFAFA]">
      <div className="h-full overflow-y-auto px-3 pb-6 pt-8">{children}</div>
    </div>
  </div>
);
